import React from "react";
import { FileText, CheckCircle2, CreditCard, CalendarCheck } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileText,
    title: "Submit Request",
    body: "Tell us what you need — services, timing, and any details.",
  },
  {
    n: "02",
    icon: CheckCircle2,
    title: "We Confirm Details",
    body: "A coordinator reviews and confirms availability with you.",
  },
  {
    n: "03",
    icon: CreditCard,
    title: "Payment Link Sent",
    body: "Once confirmed, we send a secure link to arrange payment.",
  },
  {
    n: "04",
    icon: CalendarCheck,
    title: "Appointment Secured",
    body: "Your visit is locked in and our team arrives prepared.",
  },
];

export const HowItWorks = () => (
  <section
    className="bg-white"
    style={{ borderTop: "1px solid #E2E8F0", borderBottom: "1px solid #E2E8F0" }}
    id="how-it-works"
    data-testid="how-it-works"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
      <div className="flex items-baseline gap-4">
        <span
          className="font-display text-xs font-medium tracking-[0.22em]"
          style={{ color: "#D4AF37" }}
        >
          PROCESS
        </span>
        <div>
          <h2
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
            style={{ color: "#0B2545" }}
          >
            How It Works
          </h2>
          <p className="mt-2 text-sm sm:text-base" style={{ color: "#475569" }}>
            From request to appointment in four simple steps.
          </p>
        </div>
      </div>
      <div className="tj-gold-rule mt-6" />

      <ol className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map(({ n, icon: Icon, title, body }) => (
          <li
            key={n}
            className="relative rounded-xl border bg-white p-6"
            style={{ borderColor: "#E2E8F0" }}
            data-testid={`how-step-${n}`}
          >
            <div className="flex items-center gap-3">
              <span
                className="grid place-items-center h-11 w-11 rounded-lg shrink-0"
                style={{ background: "rgba(11, 37, 69, 0.05)" }}
              >
                <Icon className="h-5 w-5" style={{ color: "#0B2545" }} strokeWidth={2.2} />
              </span>
              <span
                className="font-display text-2xl font-bold leading-none"
                style={{ color: "#D4AF37" }}
              >
                {n}
              </span>
            </div>
            <h3
              className="mt-5 font-display text-lg font-semibold"
              style={{ color: "#0B2545" }}
            >
              {title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed" style={{ color: "#475569" }}>
              {body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
